export enum SnackbarActions {
  CLOSE = 'Close',
  DISMISS = 'Dimiss',
  OK = 'Ok',
  NONE = '',
}
